"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_delayed_initialization_1 = require("owa-delayed-initialization");
var initializeExtensibilityContext_1 = require("./actions/initializeExtensibilityContext");
var store_1 = require("./store/store");
exports.surfaceActionsStore = store_1.default;
// Export synchronous utils and types
var getDisplayNameFromKey_1 = require("./utils/getDisplayNameFromKey");
exports.getComposeActionDisplayName = getDisplayNameFromKey_1.getComposeActionDisplayName;
exports.getReadActionDisplayName = getDisplayNameFromKey_1.getReadActionDisplayName;
exports.DIVIDER_DISPLAY_NAME = getDisplayNameFromKey_1.DIVIDER_DISPLAY_NAME;
var getIconNameFromKey_1 = require("./utils/getIconNameFromKey");
exports.getComposeActionIconName = getIconNameFromKey_1.getComposeActionIconName;
exports.getReadActionIconName = getIconNameFromKey_1.getReadActionIconName;
var getStaticActions_1 = require("./utils/getStaticActions");
exports.getComposeStaticActions = getStaticActions_1.getComposeStaticActions;
exports.getReadStaticActions = getStaticActions_1.getReadStaticActions;
exports.shouldAddActionToEnd = getStaticActions_1.shouldAddActionToEnd;
var getAddinCollection_1 = require("./utils/getAddinCollection");
exports.getAddinCollection = getAddinCollection_1.default;
var populateCommandBarWithAddins_1 = require("./utils/populateCommandBarWithAddins");
exports.populateCommandBarWithAddins = populateCommandBarWithAddins_1.default;
owa_delayed_initialization_1.runAfterInitialRender(function () {
    initializeExtensibilityContext_1.default();
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-surface-actions/lib/index.js
// module id = 2942
// module chunks = 2 3 4